import { useNavigate } from "react-router-dom";
import { componentWithCondition } from "../../../newLayout/page/components/hoc/componentWithConditionCheck";

const ShipmentLegAction = () => {
  const navigate = useNavigate();

  const handleCreate = () => {
    navigate("/shipment/leg/create");
  };

  return (
    <>
      <li className="tableButton activeState">
        <button onClick={handleCreate}>Create Shipment Leg</button>
      </li>
    </>
  );
};

export const ShipmentLegActionWithCheck = componentWithCondition(ShipmentLegAction);
